import { Controller } from '@hotwired/stimulus'
import SlimSelect from 'slim-select'
import he from 'he'

export default class extends Controller {
  static targets = ["option"]

  initialize() {
    let data

    if (this.element.hasAttribute("data-js-html")) {
      data = this.optionTargets.map((optionTarget) => {
        return {
          html: optionTarget.dataset.jsHtmlContent,
          text: he.decode(optionTarget.dataset.jsHtmlContent),
          value: optionTarget.value,
          selected: optionTarget.selected,
          placeholder: optionTarget.hasAttribute("data-placeholder")
        }
      })
    }

    const settings = {
      select: this.element,
      settings: {
        placeholderText: this.element.dataset.jsPlaceholder,
        openPosition: this.element.dataset.jsOpenDirection || "auto",
        allowDeselect: this.element.hasAttribute("data-js-allow-deselect"),
        showSearch: this.element.hasAttribute("data-js-show-search")
      },
      events: {
        beforeOpen: () => {
          // Add CSS class to the dropdown content to fix a z-index issue when the dropdown is
          // inside a modal
          // NOTE: I tried to cssClasses: { content: "ss-content inside-modal" }, but it
          // does not support multiple classes.
          // I also tried to add this check right after initialization, but it did not work because
          // `this._select.render.content.main` had an incorrect reference for some reason I still
          // don't understand.
          if (this.element.closest(".c-modal")) {
            this._select.render.content.main.classList.add("inside-modal")
          }
        }
      },
      data
    }

    this._select = new SlimSelect(settings)
    this._select.select.showUI() // Fixes an issue where the dropdown is not show after htmx request
  }
}

export function updateSlimSelectDisabled($select) {
  if (!$select.slim) { return }

  if ($select.disabled) {
    $select.slim.disable()
  } else {
    $select.slim.enable()
  }
}

export function updateSlimSelectValue($select, newValue) {
  if (!$select.slim) { return }

  $select.slim.setSelected(newValue)
}
